<div class="main-tab-title-box">
    <mat-card-title class="main-title">Scorecard</mat-card-title>
    <div>
        <analysis-options></analysis-options>
    </div>
</div>
<mat-card-content>
    <div class="box-login">
        <span class="main-box-title-14">As this is a subscriber’s feature, you are seeing sample results. In order to  <br>see the real results of your text, <u class="main-box-value-14-bold"><a href="https://textinspector.com/subscription-details/" style="color: #2A3654;" target="_blank" rel="noopener noreferrer">SUBSCRIBE NOW.</a></u></span>
      </div>

    <button class="icon-button">
        <span class="button-block"><div><img src="../assets/images/yellow_icons/blocked-icon.svg" class="export-con"></div><span>Scorecard
            Export</span></span>
    </button>
    
    <div class="scorecard-box" style="grid-column: span 2;">
        <div id="scorecard-title">Lexical Profile ({{ currentAnalysisMode }})</div>
        <div class="scorecard-title" style="margin-bottom: 16px;">This is the overall Lexical Profile for your {{ currentAnalysisMode }}
            text. Your score is given as a percentage, with 100% indicating a high level native speaker Academic text.
            For the meaning of A1-C2 please see here.</div>
        <ng-container *ngIf="isScreenLarge; else mobileLayout">
            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="scorecard-principal-box">
                    <div class="scorecard-title">Percentage</div>
                    <div class="spinner-container">
                        <mat-progress-spinner mode="determinate" [value]="percentage !== null && percentage !== undefined ? percentage : 0" diameter="100" strokeWidth="4"
                            color="primary">
                        </mat-progress-spinner>

                        <div class="spinner-text">{{percentage ? percentage : "--"}}<div style="font-size: 15px; padding-bottom:8px ;">%</div></div>
                    </div>

                </div>
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">Metrics used</div>
                    <div class="scorecard-principal-value">{{metrics ? metrics : "--"}}</div>
                </div>
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">CEFR Level</div>
                    <div class="scorecard-principal-value">{{cefr_level ? cefr_level : "--"}}</div>
                </div>
            </div>
            <div class="scorecard-title" style="text-align: center;">Key to CEFR Levels</div>
            <div class="scorecard-box-sub scroll_scores" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('A1'), 'not-matching': !isMatchingLevel('A1')}">
                        A1
                    </div>
                    <div class="little-title">Beginner</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 6px;" [ngClass]="{'matching': isMatchingLevel('A2'), 'not-matching': !isMatchingLevel('A2')}">
                        A2
                    </div>
                    <div class="little-title">Elementary</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;" [ngClass]="{'matching': isMatchingLevel('B1'), 'not-matching': !isMatchingLevel('B1')}">
                        B1
                    </div>
                    <div class="little-title">Intermediate</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px; margin-top: 18px;" [ngClass]="{'matching': isMatchingLevel('B2'), 'not-matching': !isMatchingLevel('B2')}">
                        B2
                    </div>
                    <div class="little-title">Upper <br> Intermediate</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 2px;"[ngClass]="{'matching': isMatchingLevel('C1'), 'not-matching': !isMatchingLevel('C1')}">
                        C1
                    </div>
                    <div class="little-title">Advanced</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 2px;" [ngClass]="{'matching': isMatchingLevel('C2'), 'not-matching': !isMatchingLevel('C2')}">
                        C2
                    </div>
                    <div class="little-title">Proficiency</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 2px;" [ngClass]="{'matching': isMatchingLevel('D1'), 'not-matching': !isMatchingLevel('D1')}">
                        D1
                    </div>
                    <div class="little-title">Academic</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 3px; margin-top: 17px;" [ngClass]="{'matching': isMatchingLevel('D2'), 'not-matching': !isMatchingLevel('D2')}">
                        D2
                    </div>
                    <div class="little-title">Upper <br> Academic</div>
                </div>
            </div>
            <div id="scorecard-title">Scorecard <div class="tooltip-container">
                    <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                    <span class="tooltip-text">This is calculated by dividing the unique words by the total number of words, giving you a sense of how many unique words are used as a proportion of the total words.</span>
                  </div></div>
            <div class="scorecard-title" style="margin-bottom: 16px;">These are the metrics used to calculate the Lexical Profile for your {{currentAnalysisMode}} text. These metrics have been identified in our research as statistically significant in distinguishing between different proficiency levels. If more metrics are used the score is likely to be more reliable. Click <a href="https://textinspector.com/help/tu-lexical-profile/" class="hiperlinks" target="_blank" rel="noopener noreferrer"  >here</a> for more information.
               
            </div>
        </ng-container>
        <!--------------------->
        <!--------------------->
        <!--------------------->
        <!--------------------->
        <ng-template #mobileLayout>
            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="scorecard-principal-box">
                    <div class="scorecard-title">Percentage</div>
                    <div class="spinner-container">
                        <mat-progress-spinner mode="determinate" [value]="percentage !== null && percentage !== undefined ? percentage : 0" diameter="100" strokeWidth="4"
                            color="primary">
                        </mat-progress-spinner>

                        <div class="spinner-text">{{percentage ? percentage : "--"}}<div style="font-size: 15px; padding-bottom:8px ;">%</div></div>
                    </div>

                </div>
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">Metrics used</div>
                    <div class="scorecard-principal-value">{{metrics ? metrics : "--"}}</div>
                </div>
                
            </div>
            <div class="scorecard-box-sub scorecard-box-sub2" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
            <div class="scorecard-principal-box">
                <div class="scorecard-principal-title">CEFR Level</div>
                <div class="scorecard-principal-value">{{cefr_level ? cefr_level : "--"}}</div>
            </div>
        </div>
            <div class="scorecard-title" style="text-align: center;">Key to CEFR Levels</div>
            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                    <div class="vertical-box cefr-box"style="border: none;">
                        <div class="scorecard-score-box" style="margin-left: 8px;" [ngClass]="{'matching': isMatchingLevel('A1'), 'not-matching': !isMatchingLevel('A1')}">
                            A1
                        </div>
                        <div class="little-title">Beginner</div>
                    </div>
                    <div class="vertical-box cefr-box"style="border: none;">
                        <div class="scorecard-score-box" style="margin-left: 8px;" [ngClass]="{'matching': isMatchingLevel('A2'), 'not-matching': !isMatchingLevel('A2')}">
                            A2
                        </div>
                        <div class="little-title">Elementary</div>
                    </div>
                    <div class="vertical-box cefr-box"style="border: none;">
                        <div class="scorecard-score-box" style="margin-left: 8px;" [ngClass]="{'matching': isMatchingLevel('B1'), 'not-matching': !isMatchingLevel('B1')}">
                            B1
                        </div>
                        <div class="little-title">Intermediate</div>
                    </div>
                    <div class="vertical-box cefr-box"style="border: none;">
                        <div class="scorecard-score-box" style="margin-left: 8px; margin-top: 18px;" [ngClass]="{'matching': isMatchingLevel('B2'), 'not-matching': !isMatchingLevel('B2')}">
                            B2
                        </div>
                        <div class="little-title">Upper <br> Intermediate</div>
                    </div>
                </div>
    
                <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="vertical-box cefr-box"style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;" [ngClass]="{'matching': isMatchingLevel('C1'), 'not-matching': !isMatchingLevel('C1')}">
                        C1
                    </div>
                    <div class="little-title">Advanced</div>
                </div>
                <div class="vertical-box cefr-box"style="border: none;">
                    <div class="scorecard-score-box" style=" margin-left: 8px;" [ngClass]="{'matching': isMatchingLevel('C2'), 'not-matching': !isMatchingLevel('C2')}">
                        C2
                    </div>
                    <div class="little-title">Proficiency</div>
                </div>
                <div class="vertical-box cefr-box"style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;" [ngClass]="{'matching': isMatchingLevel('D1'), 'not-matching': !isMatchingLevel('D1')}">
                        D1
                    </div>
                    <div class="little-title">Academic</div>
                </div>
                <div class="vertical-box cefr-box"style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px; margin-top: 17px;" [ngClass]="{'matching': isMatchingLevel('D2'), 'not-matching': !isMatchingLevel('D2')}">
                        D2
                    </div>
                    <div class="little-title">Upper <br> Academic</div>
                </div>
            </div>
        </ng-template>

    </div>

    <div class="scorecard-box">
        <div id="scorecard-title">Statistics</div>
        <div id="scorecard-box-sub">
            <div class="scorecard-value">{{averageSyllablesPerSentence ? averageSyllablesPerSentence : "--"}} <div class="scorecard-title">Average syllables per sentence</div></div>
            <div class="scorecard-score-box" style="background-color: #FCDCD2;">{{cefr_level ? cefr_level : "--"}}</div>
        </div>
        <div id="scorecard-box-sub">
            <div class="scorecard-value">{{syllablesPer100Words ? syllablesPer100Words : "--"}} <div class="scorecard-title">Syllables per 100 words</div></div>
            <div class="scorecard-score-box" style="background-color: #FCDCD2;">{{cefr_level ? cefr_level : "--"}}</div>
        </div>
        <div id="scorecard-box-sub">
            <div class="scorecard-value">{{wordsWithMoreThan2SyllablesPercentage ? wordsWithMoreThan2SyllablesPercentage : "--"}}% <div class="scorecard-title">Words with more than 2 syllables</div></div>
            <div class="scorecard-score-box" style="background-color: #FCDCD2;">{{cefr_level ? cefr_level : "--"}}</div>
        </div>
    </div>

    <div class="scorecard-box">
        <div id="scorecard-title">Readability</div>
        <div id="scorecard-box-sub">
            <div class="scorecard-value">{{flesch_reading ? flesch_reading : "--"}}<div class="scorecard-title">Flesch Kincaid Reading Ease</div></div>
            <div class="scorecard-score-box" style="background-color: #FCDCD2;">{{cefr_level ? cefr_level : "--"}}</div>
        </div>
        <div id="scorecard-box-sub">
            <div class="scorecard-value">{{flesch_kincaid ? flesch_kincaid : "--"}} <div class="scorecard-title">Flesch Kincaid Reading Grade</div></div>
            <div class="scorecard-score-box" style="background-color: #FCDCD2;">{{cefr_level ? cefr_level : "--"}}</div>
        </div>
    </div>

</mat-card-content>